module.exports = __webpack_public_path__ + "img/avatar-generic.8e52b8c8.png";